import React, { useState, useEffect } from "react";
import db, { storage } from "../firebase";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

import {
  Button,
  Heading,
  Box,
  Input,
  useToast,
  Select,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
  FormControl,
  FormLabel,
} from "@chakra-ui/react";
import styled from "@emotion/styled";

function AddProperty() {
  const toast = useToast();
  const [title, setTitle] = useState("");
  const [location, setLocation] = useState("");
  const [description, setDescription] = useState("");
  const [price, setPrice] = useState(30);
  const [type, setType] = useState();
  const [bed, setBed] = useState(1);
  const [bathroom, setBathroom] = useState(1);
  const [bedroom, setBedroom] = useState(1);
  const [guest, setGuest] = useState(1);
  const [imagesUrls, setUrls] = useState();
  const [uploaded, setUploaded] = useState(false);
  const userId = useSelector((state) => state.user.userId);
  const history = useHistory();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const filesUploaded = [];

  const onFileChange = (e) => {
    const files = e.target.files;
    for (var i = 0; i < files.length; i++) {
      filesUploaded.push(files[i]);
    }
    uploadImages();
  };

  const uploadImages = () => {
    if (filesUploaded.length == 0) {
      return;
    }

    let urls = [];
    for (var i = 0; i < filesUploaded.length; i++) {
      let storageRef = storage.ref("propertyImages/" + filesUploaded[i].name);
      let uploadTask = storageRef.put(filesUploaded[i]);
      uploadTask.on(
        "state_changed",
        (snapshot) => {},
        (error) => {},
        () => {
          uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            urls.push(downloadURL);
          });
        }
      );
    }
    setUrls(urls);
    toast({
      title: "Success !",
      description: "Picture(s) uploaded!",
      status: "success",
      duration: 2000,
      isClosable: true,
    });
    setUploaded(true);
  };

  const submitProperty = (event) => {
    event.preventDefault();
    if (
      title.trim().length == 0 ||
      description.trim().length == 0 ||
      location.trim().length == 0
    ) {
      toast({
        title: "Missing fields",
        description: "Please fill all the fileds.",
        status: "error",
        duration: 2000,
        isClosable: true,
      });
      return;
    }
    let data = {
      bathroom: bathroom,
      bedrooms: bedroom,
      beds: bed,
      description: title,
      guests: guest,
      images: imagesUrls,
      location: location,
      price: price,
      rating: 0,
      reviews: 0,
      subdescription: description,
      type: type,
      userId: userId,
      available: true,
    };

    db.collection("properties")
      .add(data)
      .then((doc) => {
        toast({
          title: "Success !",
          description: "Property posted!",
          status: "success",
          duration: 2000,
          isClosable: true,
        });
        history.push(`/property/details/${doc.id}`);
      });
  };

  return (
    <MainDiv>
      <Heading as="h1">Add a property</Heading>
      <Box maxW="80%" borderWidth="1px" borderRadius="lg" overflow="hidden">
        <form onSubmit={submitProperty}>
          <FormControl margin={10} width="280px" id="title" marginBottom={5}>
            <FormLabel>Title</FormLabel>
            <Input
              type="text"
              value={title}
              onChange={(event) => setTitle(event.target.value)}
            />
          </FormControl>
          <FormControl margin={10} width="280px" id="title" marginBottom={5}>
            <FormLabel>Location</FormLabel>
            <Input
              type="text"
              placeholder="Example: Los Angeles, California"
              value={location}
              onChange={(event) => setLocation(event.target.value)}
            />
          </FormControl>
          <FormControl margin={10} width="280px" id="fullname" marginBottom={5}>
            <FormLabel>Description</FormLabel>
            <Input
              type="text"
              value={description}
              onChange={(event) => setDescription(event.target.value)}
            />
          </FormControl>
          <FormControl margin={10} width="280px" id="fullname" marginBottom={5}>
            <FormLabel>Type</FormLabel>
            <Select
              placeholder="Select a type"
              value={type}
              defaultValue="treehouse"
              onChange={(event) => setType(event.target.value)}
            >
              <option value="treehouse">Tree house</option>
              <option value="beachfront">Beachfront</option>
              <option value="boat">Boat</option>
              <option value="tiny">Tiny home</option>
            </Select>
          </FormControl>
          <FormControl margin={10} width="280px" id="password" marginBottom={5}>
            <FormLabel>Price per night ($)</FormLabel>
            <NumberInput
              value={price}
              onChange={(event) => setPrice(event)}
              defaultValue={30}
              min={30}
            >
              <NumberInputField />
              <NumberInputStepper>
                <NumberIncrementStepper />
                <NumberDecrementStepper />
              </NumberInputStepper>
            </NumberInput>
          </FormControl>
          <FormControl margin={10} width="280px" id="password" marginBottom={5}>
            <FormLabel>Number of bed(s)</FormLabel>
            <NumberInput
              value={bed}
              onChange={(event) => setBed(event)}
              defaultValue={1}
              min={1}
            >
              <NumberInputField />
              <NumberInputStepper>
                <NumberIncrementStepper />
                <NumberDecrementStepper />
              </NumberInputStepper>
            </NumberInput>
          </FormControl>
          <FormControl margin={10} width="280px" id="password" marginBottom={5}>
            <FormLabel>Number of bathroom(s)</FormLabel>
            <NumberInput
              value={bathroom}
              onChange={(event) => setBathroom(event)}
              defaultValue={1}
              min={1}
            >
              <NumberInputField />
              <NumberInputStepper>
                <NumberIncrementStepper />
                <NumberDecrementStepper />
              </NumberInputStepper>
            </NumberInput>
          </FormControl>
          <FormControl margin={10} width="280px" id="password" marginBottom={5}>
            <FormLabel>Number of bedrooms(s)</FormLabel>
            <NumberInput
              value={bedroom}
              onChange={(event) => setBedroom(event)}
              defaultValue={1}
              min={1}
            >
              <NumberInputField />
              <NumberInputStepper>
                <NumberIncrementStepper />
                <NumberDecrementStepper />
              </NumberInputStepper>
            </NumberInput>
          </FormControl>
          <FormControl margin={10} width="280px" id="password" marginBottom={5}>
            <FormLabel>Allowed guest(s)</FormLabel>
            <NumberInput
              value={guest}
              onChange={(event) => setGuest(event)}
              defaultValue={1}
              min={1}
            >
              <NumberInputField />
              <NumberInputStepper>
                <NumberIncrementStepper />
                <NumberDecrementStepper />
              </NumberInputStepper>
            </NumberInput>
          </FormControl>
          {!uploaded ? (
            <FormControl
              margin={10}
              width="280px"
              id="password"
              marginBottom={5}
            >
              <FormLabel>Property pictures</FormLabel>

              <LabelUpload>
                Upload
                <input
                  type="file"
                  name="fileToUpload"
                  id="fileToUpload"
                  multiple
                  onChange={onFileChange}
                />
              </LabelUpload>
            </FormControl>
          ) : (
            "Pictures uploaded."
          )}
          {uploaded && (
            <Button
              type="submit"
              color="white"
              bgColor="#EE575D"
              _hover={{ color: "#EE575D", bgColor: "#EDF2F7" }}
              margin={5}
              loadingText="Signin up..."
            >
              Add property
            </Button>
          )}
        </form>
      </Box>
    </MainDiv>
  );
}

export default AddProperty;

const MainDiv = styled.div`
  margin-top: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  h1 {
    margin: 30px 0px;
  }

  form {
    flex-direction: row;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  }
`;

const LabelUpload = styled.label`
  height: 40px;
  width: auto;
  color: white;
  padding: 10px;
  border-radius: 4px;
  background-color: #ee575d;
  cursor: pointer;
  margin: 20px;
  input {
    visibility: hidden;
    width: 0.1px;
    height: 0.1px;
  }
`;
